import { createFileRoute } from '@tanstack/react-router';
import { DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CopyButton } from '@interxfi/design-system/components/copy-button/copy-button';
import { getPortfolioTransactionDetailPath } from '../../../../../../../../../../features/portfolio/transaction/portfolio-transaction-routing';
import { AccountPortfolioTransactionDetailPage } from '../../../../../../../../../../features/registration/account/portfolio/detail-page/account-portfolio-transaction-detail-page';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction/$transactionId')(
  {
    loader: ({ params }) =>
      ({
        breadcrumb: buildBreadcrumb({
          id: `portfolio-transaction-${params.transactionId}`,
          label: 'Transaction',
          to: getPortfolioTransactionDetailPath(params.accountId, params.transactionId),
          suffix: (
            <CopyButton
              content={params.transactionId}
              label="Copy Transaction ID"
              tooltip={{ copy: params.transactionId, copied: 'Copied Transaction ID' }}
            />
          ),
        }),
      }) satisfies AggregateBreadcrumb,
    head: () => getPageHead('Transaction'),
    component: AccountPortfolioTransactionDetail,
  },
);

function AccountPortfolioTransactionDetail() {
  const { accountId, transactionId } = Route.useParams();

  return (
    <AccountPortfolioTransactionDetailPage
      accountId={accountId}
      maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}
      transactionId={transactionId}
    />
  );
}
